export default __webpack_public_path__ + "static/media/andes_a_la_costa_22.60441e92.jpg";